export default "__VITE_ASSET__MLBhvh3t__"